export const constantFormValues = {
	version: {
		key: 'version',
		label: '',
	},
	paymentModalitylabel: {
		key: 'paymentModalitylabel',
		label: '',
	},
	LeaseId: {
		key: 'leaseId',
		label: 'Lease ID',
	},
	leaseType: {
		key: 'leaseType',
		label: 'Lease Type',
		options: [
			{ key: 'finance_lease', value: 'Finance Lease', label: 'Finance Lease' },
			{ key: 'operating_lease', value: 'Operating Lease', label: 'Operating Lease' },
		],
		rules: [
			{
				required: true,
				message: 'Lease Type is required',
			},
		],
	},
	leaseTitle: {
		key: 'leaseTitle',
		label: 'Lease Description',
		rules: [
			{
				required: true,
				message: 'Lease Description is required',
			},
		],
	},
	leaseSimulationTitle: {
		key: 'leaseSimulationTitle',
		label: 'Lease Simulation Title',
		rules: [
			{
				required: true,
				message: 'Lease Simulation Title is required',
			},
		],
	},
	lessorName: {
		key: 'lessorName',
		label: 'Name of Lessor',
		rules: [
			{
				required: true,
				message: 'Name of Lessor is required',
			},
		],
	},
	upfrontLeasePayment: {
		key: 'upfrontLeasePayment',
		label: 'Upfront Lease Payment',
		rules: [
			{
				required: true,
				message: 'Upfront Lease Payment is required',
			},
		],
	},
	initialDirectCost: {
		key: 'initialDirectCost',
		label: 'Initial Direct Cost',
		rules: [
			{
				required: true,
				message: 'Initial Direct Cost is required',
			},
		],
	},
	securityDeposit: {
		key: 'securityDeposit',
		label: 'Security Deposit',
		rules: [
			{
				required: false,
				// message: 'Security Deposit is required',
			},
		],
	},
	cashIncentiveAmount: {
		key: 'cashIncentiveAmount',
		label: 'Cash Incentive',
		rules: [
			{
				required: false,
				// message: 'Security Deposit is required',
			},
		],
	},
	// refundDate: {
	// 	key: 'refundDate',
	// 	label: 'Refund Date',
	// 	rules: [
	// 		{
	// 			required: false,
	// 			// message: 'Refund Date is required',
	// 		},
	// 	],
	// },
	endOfFinancialYear: {
		key: 'endOfFinancialYear',
		label: 'End of Financial Year',
		rules: [
			{
				required: false,
				message: 'End of Financial Year is required',
			},
		],
	},

	paymentFrequency: {
		key: 'paymentFrequency',
		label: 'Payment Frequency',
		options: [
			{ key: 'Monthly', value: 'Monthly', label: 'Monthly' },
			{ key: 'Quarterly', value: 'Quarterly', label: 'Quarterly' },
		],
		rules: [
			{
				required: true,
				message: 'Payment Frequency is required',
			},
		],
	},
	paymentModality: {
		key: 'paymentModality',
		label: 'Payment Modality',
		options: [
			{ key: 'Start', value: 'Start', label: 'Advance Basis' },
			{ key: 'End', value: 'End', label: 'Accrual Basis' },
		],
		rules: [
			{
				required: true,
				message: 'Payment Modality is required',
			},
		],
	},
	paymentMethod: {
		key: 'paymentMethod',
		label: 'Payment Method',
		options: [
			// { key: 'Start', value: 'Start', label: 'Advance Basis' },
			// { key: 'End', value: 'End', label: 'Accrual Basis' },
		],
		rules: [
			{
				required: false,
				message: 'Payment Modality is required',
			},
		],
	},
	creationDate: {
		key: 'creationDate',
		label: 'Creation Date',
		rules: [
			{
				required: false,
			},
		],
	},
	lastModifiedDate: {
		key: 'lastModifiedDate',
		label: 'Last Modified Date',
		rules: [
			{
				required: false,
			},
		],
	},
	advanceAmount: {
		key: 'advanceAmount',
		label: 'Advance Amount',
		rules: [
			{
				required: false,
				// message: 'Advance Amount is required',
			},
		],
	},
	advanceDuration: {
		key: 'advanceDuration',
		label: 'No of Adjustment Period',
		rules: [
			{
				required: true,
				message: 'No of Adjustment Period is required',
			},
		],
	},
	grossRent: {
		key: 'grossRent',
		label: 'Monthly Gross Rent',
		rules: [
			{
				required: false,
				message: 'Monthly Gross Rent is required',
			},
		],
	},
	leaseTerm: {
		key: 'leaseTerm',
		label: 'Total Lease Periods',
		rules: [
			{
				required: true,
				message: 'Total Lease Periods is required',
			},
		],
	},
	leaseStartDate: {
		key: 'leaseStartDate',
		label: 'Lease Start Date',
		rules: [
			{
				required: true,
				message: 'Lease Start Date is required',
			},
		],
	},
	leaseEndDate: {
		key: 'leaseEndDate',
		label: 'Lease End Date',
		rules: [
			{
				required: false,
			},
		],
	},
	escalationPercentage: {
		key: 'escalationPercentage',
		label: 'Escalation (%)',
		rules: [
			{
				required: true,
				message: 'Escalation (%) is required',
			},
		],
	},
	inputChangeMonth: {
		key: 'inputChangeMonth',
		label: '',
	},
	initialDiscountRate: {
		key: 'initialDiscountRate',
		label: 'Incremental Borrowing Rate',
		rules: [
			{
				required: false,
				message: 'Incremental Borrowing Rate is required',
			},
		],
	},
	rightOfUseAssetValue: {
		key: 'rightOfUseAssetValue',
		label: 'Right of Use Asset',
		options: [
			{ key: '10000250 - RoU Front Offices', value: '10000250 - RoU Front Offices', label: '10000250 - RoU Front Offices' },
			{ key: '10000251 - RoU Back Offices', value: '10000251 - RoU Back Offices', label: '10000251 - RoU Back Offices' },
		],
		rules: [
			{
				required: true,
				message: 'Right of Use Asset is required',
			},
		],
	},
	glleaseLiability: {
		key: 'glleaseLiability',
		label: 'Lease Liability',
		options: [
			{ key: '20001120 - Lease Liabilities', value: '20001120 - Lease Liabilities', label: '20001120 - Lease Liabilities' },
			{ key: '20001125 - Lease Liabilities', value: '20001125 - Lease Liabilities', label: '20001125 - Lease Liabilities' },
		],
		rules: [
			{
				required: false,
			},
		],
	},
	costCenterInterestExpense: {
		key: 'costCenterInterestExpense',
		label: 'Interest Expense (Cost Center)',
		options: [{ key: '902001 - Finance Common', value: '902001 - Finance Common', label: '902001 - Finance Common' }],
		rules: [
			{
				required: false,
			},
		],
	},
	glInterestExpense: {
		key: 'glInterestExpense',
		label: 'Interest Expense',
		options: [{ key: '40004250 - Interest for Lease', value: '40004250 - Interest for Lease', label: '40004250 - Interest for Lease' }],
		rules: [
			{
				required: false,
			},
		],
	},
	leaseExpenseCostCenter: {
		key: 'leaseExpenseCostCenter',
		label: 'Lease Expense (Cost Center)',
		options: [{ key: '902002 - Finance Common', value: '902002 - Finance Common', label: '902002 - Finance Common' }],
		rules: [
			{
				required: false,
			},
		],
	},
	leaseExpense: {
		key: 'leaseExpense',
		label: 'Lease Expense',
		options: [{ key: '40004260 - Interest for Lease', value: '40004260 - Interest for Lease', label: '40004260 - Interest for Lease' }],
		rules: [
			{
				required: false,
			},
		],
	},
	leasePayableControlAccount: {
		key: 'leasePayableControlAccount',
		label: 'Lease Payable Control A/C',
		options: [{ key: '20001100 - Lease Payable', value: '20001100 - Lease Payable', label: '20001100 - Lease Payable' }],
		rules: [
			{
				required: false,
			},
		],
	},
	glAdvanceRent: {
		key: 'glAdvanceRent',
		label: 'Advance Rent',
		options: [{ key: '10002050 - Advance Rent', value: '10002050 - Advance Rent', label: '10002050 - Advance Rent' }],
		rules: [
			{
				required: false,
			},
		],
	},
	depreciationRoUCostCenter: {
		key: 'depreciationRoUCostCenter',
		label: 'Depreciation - RoU (Cost Center)',
		options: [{ key: '902003 - Finance Common', value: '902003 - Finance Common', label: '902003 - Finance Common' }],
		rules: [
			{
				required: false,
			},
		],
	},
	depreciationRoU: {
		key: 'depreciationRoU',
		label: 'Depreciation - RoU',
		options: [{ key: '20007555 - Depreciation RoU', value: '20007555 - Depreciation RoU', label: '20007555 - Depreciation RoU' }],
		rules: [
			{
				required: false,
			},
		],
	},
	accumDepreciationRoU: {
		key: 'accumDepreciationRoU',
		label: 'Accum Depreciation - RoU',
		options: [
			{ key: '20004255 - Accum Depreciation RoU', value: '20004255 - Accum Depreciation RoU', label: '20004255 - Accum Depreciation RoU' },
		],
		rules: [
			{
				required: false,
			},
		],
	},
	glBankAccount: {
		key: 'glBankAccount',
		label: 'Bank Account',
		options: [{ key: '10003001 - SCB Main', value: '10003001 - SCB Main', label: '10003001 - SCB Main' }],
		rules: [
			{
				required: false,
			},
		],
	},
	securityDepositHead: {
		key: 'securityDepositHead',
		label: 'Security Deposit',
		options: [{ key: '10009008 - Security Deposit', value: '10009008 - Security Deposit', label: '10009008 - Security Deposit' }],
		rules: [
			{
				required: false,
			},
		],
	},
	accountsPayableHead: {
		key: 'accountsPayableHead',
		label: 'Accounts Payable',
		options: [{ key: '20003300 - Accounts Payable', value: '20003300 - Accounts Payable', label: '20003300 - Accounts Payable' }],
		rules: [
			{
				required: false,
			},
		],
	},
	changes: {
		key: 'changes',
		orderedRowHeader: [
			'inputChangeEffectiveDate',
			'inputChangeDescription',

			'inputChangeLeaseTerm',
			// 'inputChangeGrossAmount',
			'inputChangeDiscountRate',
			// 'inputChangeEscalation',
			'paymentFrequency',
			'paymentTime',
		],
		changeList: {
			inputChangeEffectiveDate: {
				key: 'inputChangeEffectiveDate',
				label: 'Effective Date',
				rules: [
					{
						required: true,
						message: 'Effective Date is required',
					},
				],
			},
			inputChangeLeaseTerm: {
				key: 'inputChangeLeaseTerm',
				label: 'Lease Periods',
			},
			inputChangeGrossAmount: {
				key: 'inputChangeGrossAmount',
				label: 'Monthly Gross Rent',
			},
			inputChangeDiscountRate: {
				key: 'inputChangeDiscountRate',
				label: 'IBR (%)',
			},
			inputChangeEscalation: {
				key: 'inputChangeEscalation',
				label: 'Escalation (%)',
			},
			paymentFrequency: {
				key: 'paymentFrequency',
				label: 'Payment Frequency',
				options: [
					{
						key: 'Monthly`',
						value: 'Monthly',
						label: 'Monthly',
					},
					{
						key: 'Quarterly',
						value: 'Quarterly',
						label: 'Quarterly',
					},
				],
			},
			paymentTime: {
				key: 'paymentTime',
				label: 'Payment Modality',
				options: [
					{
						key: 'Start`',
						value: 'Start',
						label: 'Advance Basis',
					},
					{
						key: 'End',
						value: 'End',
						label: 'Accrual Basis',
					},
				],
			},
			inputChangeDescription: {
				key: 'inputChangeDescription',
				label: 'Payment Schedule',
				options: [
					{
						key: 'initialLeaseTerm',
						value: 'Initial Rent',
						label: 'Initial Rent',
					},
					{
						key: 'changeInRent',
						value: 'Change In Rent',
						label: 'Change In Rent',
					},
				],
			},
		},
	},
};
